// FILE: client/src/pages/Disclaimer.js

export default function Disclaimer() {
  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: "0 16px", color: "white" }}>
      <h1>Disclaimer</h1>
      <p>
        WatchParty Rooms does not host, stream, or store any media content. All content is provided by third-party platforms via user-submitted links.
        Users are responsible for ensuring they have the right to share any content.
      </p>
      <p>
        We are not affiliated with YouTube, Twitch, Kick, Netflix, or any other platform.
      </p>
    </div>
  );
}
